import React from 'react';
import '../styles/PortPage.css'; 

export default function DescripcionContent({ descripcion }) {
  
  if (!descripcion) {
    return (
      <section className="descripcion-section">
        <p>No hay una descripción disponible para este puerto.</p>
      </section>
    );
  }

  // 2. Función auxiliar para detectar enlaces dentro del texto
  const renderWithLinks = (text) => {
    // Expresión regular para encontrar URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    
    // Dividimos el texto. El regex con paréntesis () hace que el split incluya la URL.
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      // Si la parte coincide con una URL, devolvemos un link <a>
      if (part.match(urlRegex)) {
        return (
          <a 
            key={index} 
            href={part} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#007bff', 
              textDecoration: 'underline', 
              wordBreak: 'break-all' 
            }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  const paragraphs = descripcion.split('\n').filter(p => p.trim() !== '');

  return (
    <section className="descripcion-section">
      {paragraphs.map((paragraph, i) => (
        <p key={i}>
          {renderWithLinks(paragraph)}
        </p>
      ))}
    </section>
  );
}